import {initContract} from '@ts-rest/core';
import {z} from 'zod';

const c = initContract();

// Read-only catalog of tools available for assistant configuration. The
// `source` discriminator distinguishes Archie's built-in MCP tools from
// tenant-registered external MCP servers; external entries also carry
// the `serverId` / `serverDisplayName` so the UI can group them by
// origin. Tool ids for external tools are namespaced as
// `mcp:<serverId>:<toolName>` so they don't collide with built-ins.
export const toolCatalogEntrySchema = z.discriminatedUnion('source', [
  z.object({
    toolId: z.string(),
    title: z.string(),
    shortDescription: z.string(),
    source: z.literal('builtin')
  }),
  z.object({
    toolId: z.string(),
    title: z.string(),
    shortDescription: z.string(),
    source: z.literal('mcp_external'),
    serverId: z.string(),
    serverDisplayName: z.string()
  })
]);

export type ToolCatalogEntry = z.infer<typeof toolCatalogEntrySchema>;

export const toolsContract = c.router(
  {
    list: {
      method: 'GET',
      path: '/',
      query: z.object({
        // When provided, also include external tools from MCP servers
        // registered to this tenant. Omit for built-ins only.
        tenantId: z.string().uuid().optional()
      }),
      responses: {
        200: z.array(toolCatalogEntrySchema)
      },
      summary: 'List tools available for assistant configuration'
    }
  },
  {
    pathPrefix: '/tools'
  }
);
